import {useEffect,useState,useCallback} from 'react';
import {makeStyles } from '@material-ui/core/styles';
import DashboardHeader from '../common/dashboardHeader';
import {Grid, Typography, Chip} from '@material-ui/core';
import {useLocation,useParams} from 'react-router-dom';
import {api,editorContent,BRIEFS_UTIL} from '../../utility';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import Topic from '../topic';
import Drawer from '@material-ui/core/Drawer';
import Debounce from 'lodash.debounce';
import Skeleton from '@material-ui/lab/Skeleton';
import TopicBrief from './topic';
import QuestionsBrief from './questions';
import OutlineBrief from './outline';
import { Line } from 'rc-progress';

const useStyleTab = makeStyles((theme) => ({
    root: {
      color: theme.palette.common.black,
      border:'unset!important',
    },
    selected: {
        color: theme.palette.common.black+'!important',
        backgroundColor: theme.palette.common.white+'!important',
        border:'unset!important',
        borderBottomLeftRadius: '0!important',
        borderBottomRightRadius: '0!important'
    },
  }));

function Brief(props){
    const tabClasses = useStyleTab();
    const location = useLocation();
    let { id } = useParams();
    const [briefInfo, setBriefInfo] = useState({});
    const [viewState, setViewState] = useState("topic");
    const [content, setContent] = useState([]);
    const [grade , setGrade ] = useState("");
    const [wordCount, setWordCount] = useState(0);
    const [nextGradeCount, setNextGradeCount] = useState(0);
    const [topics, setTopics] = useState([]);
    const [topicName, setTopicName] = useState("");
    const [headingsSideBar, setHeadingsSideBar] = useState(false);
    const [selectedTopic, setSelectedTopic] = useState({});
    const latestContent = editorContent();
    const [showUnused, setShowUnused] = React.useState(false);

    const setUpdatedContent = useCallback(Debounce((value,content) => {
        if(value.toString() != content.toString()) {
            setContent(value);
        }
    }, 500),[]);

    const updateContentCall = () => {
        if(content && Object.keys(briefInfo).length > 0)
        fetch(api.BASE_URL+api.GET_BRIEFS+`${id}`, {
            method: 'PUT',
            headers: {
            'Authorization': `Bearer ${localStorage.aToken}`,
            'content-type': 'application/json'
            },
            body: JSON.stringify({editor_content_gdocs:content.toString()})
        }).then(function(response) {
            return response.json();
        })
        .then(function(data) {
            console.log(data);
            setGrade(data.report.content_gdocs.grade);
            setWordCount(data.report.content_gdocs.word_count);
            setNextGradeCount(data.report.content_gdocs.topics_for_next_grade)
            let newTopics = [...topics];
            newTopics.map((topic,index) => {
                if(Object.keys(data.report.content_gdocs.covered_topics).includes(topic.name)){
                    newTopics[index].covered = true;
                }else{
                    newTopics[index].covered = false;
                }
            });
            setTopics(newTopics);
        }).catch((err) =>{
            console.log(err);
        });
    }

    const handleViewChange = (value) => {
        if(value){
            setViewState(value);    
        }
    }

    useEffect(()=>{
        fetch(api.BASE_URL+api.GET_BRIEFS+`${id}`, {
            method: 'GET',
            headers: {
              'Authorization': `Bearer ${localStorage.aToken}`,
            },
        }).then(function(response) {
            return response.json();
        })
        .then(function(data) {
            console.log(data);
            setBriefInfo(data);
            setGrade(data.content_gdocs.grade);
            let newtopics = [];
            (data.report.recommended_topics).map((topic)=>{
                topic.covered = false;
                newtopics.push(topic);
            });
            setWordCount(data.content_gdocs.word_count);
            setNextGradeCount(data.content_gdocs.topics_for_next_grade);
            setTopics(newtopics);
            setTopicName(data.name);
        }).catch((err) =>{
            console.log(err);
        });
    },[]);

    useEffect(()=>{
        updateContentCall();
    },[content]);

    useEffect(()=>{
        if(topics.length > 0){
            setUpdatedContent(latestContent,content);
        }
    },[latestContent])

    const viewHeadings = (topic) => {
        setSelectedTopic(topic);
        setHeadingsSideBar(true);
    }

    const getGrade = (grade) => {
        if(grade != ""){
            if(grade == 'F'){
                    return (
                        <Typography variant="h4" style={{fontWeight:'800',color:'rgb(62 75 92)'}} gutterBottom>{grade}</Typography>  
                    );
                }else if(grade == 'D-'){
                    return (
                        <Typography variant="h4" style={{fontWeight:'800',color:'rgb(62 75 92)'}} gutterBottom>{grade}</Typography>  
                    );
                }else if(grade == 'D' || grade == 'D+'){
                    return (
                        <Typography variant="h4" style={{fontWeight:'800',color:'rgb(62 75 92)'}} gutterBottom>{grade}</Typography>  
                    );
                }else if(grade ==  'C-'|| grade == 'C' || grade == 'C+'){
                    return (
                        <Typography variant="h4" style={{fontWeight:'800',color:'rgb(62 75 92)'}} gutterBottom>{grade}</Typography>  
                    );
                }else if(grade == "B-" || grade == 'B' || grade == 'B+'){
                    return (
                        <Typography variant="h4" style={{fontWeight:'800',color:'rgb(62 75 92)'}} gutterBottom>{grade}</Typography>  
                    );
                }else if(grade == "A-"){
                    return (
                        <Typography variant="h4" style={{fontWeight:'800',color:'rgb(62 75 92)'}} gutterBottom>{grade}</Typography>  
                    );
                }else if(grade == 'A' || grade == 'A+' || grade == 'A++'){
                    return (
                        <Typography variant="h4" style={{fontWeight:'800',color:'rgb(62 75 92)'}} gutterBottom>{grade}</Typography>  
                    );
                }
        }else{
            return(
                <Typography variant="h4" style={{fontWeight:'800',color:'rgb(62 75 92)', opacity: 0}} gutterBottom>A</Typography>  
            );
        }      
    }
    const getLoaderColor = () => {
        if(briefInfo.report){
            const percentage = parseInt((wordCount/briefInfo.report.recommended_word_count) * 100);
            if(percentage < 35){
                return(
                    <Chip size="small" label={`${wordCount}`} style={{color:'white',background:'rgb(255, 76, 76)',opacity:'.5'}}/>
                );
            }else if(percentage < 75){
                return(
                    <Chip size="small" label={`${wordCount}`} style={{color:'white',background:'#fb924a',opacity:'.5'}}/>
                );
            }else if(percentage > 75){
                return(
                    <Chip size="small" label={`${wordCount}`} style={{color:'white',background:'#28b32c',opacity:'.5'}}/>
                );
            }else{
                return(
                    <Chip size="small" label={`${wordCount}`} style={{color:'white',background:'#334152',opacity:'.5'}}/>
                );
            }
        }else{
            return(
                <Chip size="small" label="" style={{color:'white',background:'#334152',opacity:'0'}}/>
            );
        }
    }

    const getProgressLoaderValues = (type,grade) => {
        if(type == "percentage"){
            const totalTopics = topics.length;
            let coveredTopic = 0;
            topics.map((singleTopic) => {
                if(singleTopic.covered){
                    coveredTopic++;
                }
            });
            const value = parseInt((coveredTopic/totalTopics)*100);
            if(value > 5){
                return value;
            }else{
                return 5;
            }
        }else if(type == "color"){
            if(grade != ""){
                if(grade == 'F'){
                        return '#ff4c4c';
                    }else if(grade == 'D-'){
                        return '#fd6f4b';
                    }else if(grade == 'D' || grade == 'D+'){
                        return '#005a87';
                    }else if(grade ==  'C-'|| grade == 'C' || grade == 'C+'){
                        return '#9c9c31'; 
                    }else if(grade == "B-" || grade == 'B' || grade == 'B+'){
                        return '#8FBC8F';
                    }else if(grade == "A-"){
                        return '#556B2F'; 
                    }else if(grade == 'A' || grade == 'A+' || grade == 'A++'){
                        return '#006400';
                    }
            }else{
                return "rgb(255, 76, 76)";
            }      
        }
    };

    const css = `
        .brief button[aria-pressed="true"] .MuiTypography-subtitle2{
            font-weight: bold !important;
        }
        .brief button[aria-pressed="false"] .MuiTypography-subtitle2{
            font-weight: normal !important;
        }
    `;

    return(
        <Grid container xs="12" md="12" direction="row" className="brief">
            <style>{css}</style>
            <Grid></Grid>
            <DashboardHeader goBack={true} TopicName={topicName} Briefs={props.Briefs} isNotLoggedIn={(location && location.state && location.state.isNotLoggedIn) ? true : false}/>
            <Grid xs="12" item style={{textAlign:'center',background:'rgb(249, 249, 249)'}} >
                 <Grid container xs="12" alignContent="center" justify="center"> 
                     <Grid item xs="8" style={{textAlign:'center'}}>
                     <Typography variant="caption" display="block" style={{fontWeight:'500',color:'#334152'}}>{BRIEFS_UTIL.CURRENT_GRADE_TEXT}</Typography>
                    {getGrade(grade)}
                     {(briefInfo && briefInfo.report) ?
                        <div style={{position: 'absolute', top: '97px',right: '75px',fontSize: '14px', display: 'none'}}>
                             <Typography variant="h4" style={{fontWeight:'800',color:'#567393'}}>{briefInfo.report.recommended_grade}</Typography>  
                            <div style={{height:'24px',width:'1px',borderLeft:'1px dashed',marginLeft: '14px'}}>
                            </div>
                        </div>
                        : null }
                        <Line percent={getProgressLoaderValues("percentage")} strokeWidth="7" trailWidth="7" strokeColor={getProgressLoaderValues("color",grade)} />
                     </Grid>
                 </Grid>
                 <Typography variant="subtitle2" display="block" style={{color:'#334152',marginBottom:'20px', fontSize: '12px'}}>Cover {nextGradeCount === 0 ? 1 : nextGradeCount} more topic{nextGradeCount <= 1 ? '' : 's'} to reach next grade</Typography>
                 <Typography variant="subtitle2" display="block" style={{color:'#334152'}}>{BRIEFS_UTIL.WORD_COUNT_TEXT} {getLoaderColor()}&nbsp;&nbsp;/&nbsp;&nbsp;{(briefInfo.report) ? briefInfo.report.recommended_word_count : 'loading..'}</Typography>
             </Grid>
            <Grid item xs="12" item style={{textAlign:'center',background:'rgb(249, 249, 249)', marginTop: '26px'}}>
                <Grid container spacing={2} direction="column" alignItems="center">
                    <Grid item>
                    
                        <ToggleButtonGroup value={viewState} exclusive onChange={(event,value) => {handleViewChange(value)}}>
                            <ToggleButton value="topic" classes={tabClasses}>
                                <Typography variant="subtitle2" style={{fontSize:'0.8rem'}}>{BRIEFS_UTIL.SELECT_TOPIC_TEXT}</Typography>
                            </ToggleButton>
                            <ToggleButton value="questions" classes={tabClasses}>
                                <Typography variant="subtitle2" style={{fontSize:'0.8rem'}}>{BRIEFS_UTIL.SELECT_QUESTIONS_TEXT}</Typography>
                            </ToggleButton>
                            <ToggleButton value="outlines" classes={tabClasses}>
                                <Typography variant="subtitle2" style={{fontSize:'0.8rem'}}>{BRIEFS_UTIL.SELECT_OUTLINES_TEXT}</Typography>
                            </ToggleButton>
                        </ToggleButtonGroup>
                    </Grid>
                </Grid>
            </Grid>
            {(viewState == "topic") ?
             <TopicBrief 
             showUnused={showUnused}
             setShowUnused={setShowUnused}
             viewHeadings={viewHeadings}
             topics={topics}/>
            : null }
            {(viewState == "questions") ? 
                <QuestionsBrief briefInfo={briefInfo}/>
            :null}
            {(viewState == "outlines") ? 
                <OutlineBrief briefInfo={briefInfo}/>
            :null}
            <Drawer anchor="right" open={headingsSideBar} onClose={()=>setHeadingsSideBar(false)}>
                <Topic topic={selectedTopic} close={() => setHeadingsSideBar(false)}/>
            </Drawer>
        </Grid>
    );

}

export default Brief;